import * as React from 'react';

export const Maintenance: React.FC = () =>
  <div style={{width: '100%', backgroundColor: '#ffffff', height: '100%'}}>
    <div style={{margin: 'auto', maxWidth: '800px', paddingTop: '200px'}}>
      <h1 style={{ fontSize: '3rem', marginTop: 0 }}>
        We'll be back soon
      </h1>
      <p style={{ fontSize: '1.3rem', lineHeight: '1.5em' }}>
        Sorry for the inconvenience,
        we are currently performing some maintenance at the moment.
        Please contact the Concierge Desk or Centre Management to collect your tourist passport,
        otherwise we will be back online shortly.
      </p>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/components/Maintenance.tsx